<template>
  <editor :id="data_id" :data="id" :default-tab="defaultTab || 'list_data'" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Basic from './list_data/Editor'

export default {
  props: ['data_id','id','prependExtraTabs','appendExtraTabs','defaultTab'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        ...this.prependExtraTabs,
        {title: "List data", name: "list_data", component: Basic},
        ...this.appendExtraTabs
      ]
    }
  }
}
</script>
